import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Divider, Flex, Row, Space, Typography } from "antd";
import { BaseContainer } from "components/containers";
import { DataGrid, FillButton } from "components/elements";
import { BaseSection, TitleLayout } from "components/layouts";
import { DownloadButton, } from 'components/elements/Button';
import { closeDetailData1, closeDetailData2, closeDetailData3, closeDetailData4, closeDetailData5 } from "data/branch/branch-close";
import { URL_ADMIN, URL_ADMIN_BRANCH, URL_BRANCH_CLOSING_REPORT_PERFORMANCE } from 'routes/AdminRoute'
import { getBranchClosingReportDetail } from "api/branch";

const { Title } = Typography;
export default function HqBranchCloseReportClose () {
  const navigate = useNavigate();

  const { state } = useLocation();
  const { branchIdx, year, month, reportIdx } = state;
  const yyyymm = year + month

  const columnName1 = ['STORE_CONTRACT_DATE', 'STORE_CONTRACT_ACTIVITY_CONTENT', 'STORE_CONTRACT_PROMOTION_TARGET', 'STORE_CONTRACT_PROMOTION_CONTENT', 'STORE_CONTRACT_BRIEFING_DATE', 'STORE_CONTRACT_BRIEFING_PLACE', 'CANCEL_SCHOOL_MANAGE_TARGET', 'CANCEL_SCHOOL_MANAGE_CONTENT'];
  const columnName2 = ['STRATEGY_ACTIVITY_NEW_JOIN', 'STRATEGY_ACTIVITY_REJOIN', 'REGRESS_MANAGE_ACTIVITY_TARGET', 'REGRESS_MANAGE_ACTIVITY_CONTENT', 'ADDITIONAL_ACTIVITY'];
  const columnName3 = ['PROMOTION_ONLINE_NAVERCAFE', 'PROMOTION_ONLINE_BLOG', 'PROMOTION_ONLINE_LUCKY', 'PROMOTION_ONLINE_NEW_MOMCAFE_NAME', 'PROMOTION_ONLINE_NEW_MOMCAFE_ACTIVITY_CONTENT', 'PROMOTION_ONLINE_NEW_MOMCAFE_UPDATE_CNT', 'PROMOTION_ONLINE_ALBA_UPDATE_CNT', 'PROMOTION_ONLINE_ALBA_UPDATE_DATE', 'PROMOTION_ONLINE_ADDITIONAL_ACTIVITY', 'PROMOTION_OFFLINE_OUTDOOR', 'PROMOTION_OFFLINE_DIRECT', 'PROMOTION_OFFLINE_ADDITIONAL_ACTIVITY'];
  const columnName4 = ['NEW_CONTRACT_EDU_SCHOOL', 'NEW_CONTRACT_EDU_REACTION', 'NEW_CONTRACT_EDU_NECESSARY', 'RE_EDU_DATE', 'RE_EDU_SUBJECT', 'RE_EDU_TARGET', 'RE_EDU_ADDITIONAL_ACTIVITY'];
  const columnName5 = ['MONTHLY_MEETING_DATE1', 'MONTHLY_MEETING_DATE2', 'MONTHLY_MEETING_DATE3', 'MONTHLY_MEETING_DATE4', 'MONTHLY_MEETING_DATE5', 'MONTHLY_MEETING_PLACE', 'MONTHLY_MEETING_ABSENCE_SCHOOL', 'MONTHLY_MEETING_ABSENCE_SCHOOL_FILE_PATH', 'MONTHLY_MEETING_SUMMARY', 'MONTHLY_MEETING_SUMMARY_FILE_PATH', 'MONTHLY_MEETING_STUDY_SUBJECT', 'MONTHLY_MEETING_STUDY_WAY', 'MONTHLY_MEETING_STUDY_RESULT', 'PROPOSE_ISSUE', 'MONTHLY_MEETING_ABSENCE_SCHOOL_FILE_PATH', 'MONTHLY_MEETING_SUMMARY_FILE_PATH'];
  const [data1, setData1] = useState(closeDetailData1)
  const [data2, setData2] = useState(closeDetailData2)
  const [data3, setData3] = useState(closeDetailData3)
  const [data4, setData4] = useState(closeDetailData4)
  const [data5, setData5] = useState(closeDetailData5)
  const [values, setValues] = useState({
    report_idx: reportIdx,
    store_contract_date: '',
    store_contract_activity_content: '',
    store_contract_promotion_target: '',
    store_contract_promotion_content: '',
    store_contract_briefing_date: '',
    store_contract_briefing_place: '',
    cancel_school_manage_target: '',
    cancel_school_manage_content: '',
    strategy_activity_new_join: '',
    strategy_activity_rejoin: '',
    regress_manage_activity_target: '',
    regress_manage_activity_content: '',
    additional_activity: '',
    promotion_online_navercafe: '',
    promotion_online_blog: '',
    promotion_online_lucky: '',
    promotion_online_new_momcafe_name: '',
    promotion_online_new_momcafe_activity_content: '',
    promotion_online_new_momcafe_update_cnt: 0, // 지역맘카페 입점 등록횟수
    promotion_online_alba_update_cnt: 0, // 알바천국 등록횟수
    promotion_online_alba_update_date: '',
    promotion_online_additional_activity: '',
    promotion_offline_outdoor: '',
    promotion_offline_direct: '',
    promotion_offline_additional_activity: '',
    new_contract_edu_school: '',
    new_contract_edu_reaction: '',
    new_contract_edu_necessary: '',
    re_edu_date: '',
    re_edu_subject: '',
    re_edu_target: '',
    re_edu_additional_activity: '',
    monthly_meeting_date1: '',
    monthly_meeting_date2: '',
    monthly_meeting_date3: '',
    monthly_meeting_date4: '',
    monthly_meeting_date5: '',
    monthly_meeting_place: '',
    monthly_meeting_absence_school: '',
    monthly_meeting_summary: '',
    monthly_meeting_study_subject: '',
    monthly_meeting_study_way: '',
    monthly_meeting_study_result: '',
    propose_issue: '',
    monthly_meeting_absence_school_file_path: '',
    monthly_meeting_summary_file_path: ''
  });

  const fnGetDetail = async () => {
    const params = {
      yyyymm: yyyymm,
      branchIdx: branchIdx,
      reportIdx: reportIdx
    }
    
    getBranchClosingReportDetail(params)
    .then((res) => {
      const dataList = res.data.data_list;
      const dataInfo = res.data.data_info;

      setData1((prevState) =>
        prevState.map((item, index) => {
          return {
            ...item,
            col4: dataInfo[columnName1[index]]
          };
        })
      );

      setData2((prevState) =>
        prevState.map((item, index) => {
          return {
            ...item,
            col4: dataInfo[columnName2[index]]
          };
        })
      );

      setData3((prevState) =>
        prevState.map((item, index) => {
          return {
            ...item,
            col4: dataInfo[columnName3[index]]
          };
        })
      );

      setData4((prevState) =>
        prevState.map((item, index) => {
          return {
            ...item,
            col4: dataInfo[columnName4[index]]
          };
        })
      );

      setData5((prevState) =>
        prevState.map((item, index) => {
          return {
            ...item,
            col4: dataInfo[columnName5[index]]
          };
        })
      );

      setValues((prevState) => {
        const updatedFields = Object.keys(dataInfo).reduce((acc, key) => {
          acc[key.toLowerCase()] = dataInfo[key];
          return acc;
        }, {});
        return {
          ...prevState,
          ...updatedFields
        };
      })
    })
  }

  useEffect(() => {
    fnGetDetail();
  }, [])

//"https://qmir-intra-dev.s3.dualstack.ap-northeast-2.amazonaws.com/2025.03.21/test2_20250321104907.jpg"
  const fnDownloadImg = async (fileUrl) => {
    console.log(fileUrl)
    try{
      const absoluteUrl = new URL(fileUrl, window.location.href).href;
      const fileName = absoluteUrl.split("/").pop();
      const a = document.createElement("a");
  
      a.href = absoluteUrl;
      a.setAttribute("download", fileName);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a)
    } catch (err) {
      console.log(err)
    } 
  }

  const columns1 = [
    {
      title: '1. 가맹 계약관리',
      align: 'center',
      dataIndex: 'col1',
      width: '15%',
      render: (value, record, idx) => {
        let rowSpan = 0;
        if (value && value !== '') {
          rowSpan = 8
        }

        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan }
        }
      }
    }, {
      title: '상세내용',
      align: 'center',
      dataIndex: 'col2',
      colSpan: 3,
      width: '13%',
      render: (value, record, idx) => {
        let rowSpan = 0;
        if(value && value !== '') {
          rowSpan = 2
        }
        
        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      dataIndex: 'col3',
      colSpan: 0,
      width: '10%',
    }, {
      title: '',
      align: 'center',
      width: '62%',
      colSpan: 0,
      dataIndex: 'col4',
    }
  ]
  const columns2 = [
    {
      title: '2. 회원관리',
      align: 'center',
      dataIndex: 'col1',
      width: '15%',
      render: (value, record, idx) => {
        let rowSpan = 0;
        if (value && value !== '') {
          rowSpan = 5
        }

        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan }
        }
      }
    }, {
      title: '상세내용',
      align: 'center',
      width: '13%',
      colSpan: 3,
      dataIndex: 'col2',
      render: (value, record, idx) => {
        let rowSpan = 0;
        let colSpan = 1;
        if (value && value !== '') {
          rowSpan = 2;
        }
        if (value === '[추가활동]') {
          colSpan = 2;
        }
        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan, colSpan: colSpan }
        }

      }
    }, {
      title: '',
      align: 'center',
      width: '10%',
      colSpan: 0,
      dataIndex: 'col3',
      render: (value, record, idx) => {
        let colSpan = 1;
        if (idx+1 === data2.length) {
          colSpan = 0;
        }

        return {
          children: <>{value}</>,
          props: { colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '62%',
      colSpan: 0,
      dataIndex: 'col4'
    }, 
  ]
  const columns3 = [
    {
      title: '3. 가맹 영업관리',
      align: 'center',
      dataIndex: 'col1',
      width: '15%',
      render: (value, record, idx) => {
        let rowSpan = 0;
        if (value === '온라인 홍보') {
          rowSpan = 9
        } else if (value === '오프라인 홍보') {
          rowSpan = 3
        }

        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan }
        }
      }
    }, {
      title: '상세내용',
      align: 'center',
      width: '13%',
      colSpan: 3,
      dataIndex: 'col2',
      render: (value, record, idx) => {
        let rowSpan = 0;
        let colSpan = 1;
        if (value === '지역맘카페 입점') {
          rowSpan = 3;
        } else if (value === '알바천국') {
          rowSpan = 2;
        }

        if (!record.col3 || record.col3 === '') {
          rowSpan = 1
          colSpan = 2
        }

        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan, colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '10%',
      colSpan: 0,
      dataIndex: 'col3',
      render: (value, record, idx) => {
        let colSpan = 0;
        if (idx===3 || idx===4 || idx===5 || idx===6 || idx===7) {
          colSpan = 1;
        }

        return {
          children: <>{value}</>,
          props: { colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '62%',
      colSpan: 0,
      dataIndex: 'col4',
    }
  ]
  const columns4 = [
    {
      title: '4. 교육관리',
      align: 'center',
      dataIndex: 'col1',
      width: '15%',
      render: (value, record) => {
        let rowSpan = 0;
        if (value) {
          rowSpan = 7
        }
        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan }
        }
      }
    }, {
      title: '상세내용',
      align: 'center',
      width: '13%',
      colSpan: 3,
      dataIndex: 'col2',
      render: (value, record, idx) => {
        let rowSpan = 0;
        let colSpan = 1;
        if (value) {
          if (value === '[추가활동]') {
            rowSpan = 1;
            colSpan = 2;
          } else {
            rowSpan = 3;
          }
        }
        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan, colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '10%',
      colSpan: 0,
      dataIndex: 'col3',
      render: (value, record, idx) => {
        let colSpan = 1;
        if (idx+1 === data4.length) {
          colSpan = 0;
        }

        return {
          children: <>{value}</>,
          props: { colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '62%',
      colSpan: 0,
      dataIndex: 'col4',
    }, 
  ]
  const columns5 = [
    {
      title: '5. 월례모임',
      align: 'center',
      dataIndex: 'col1',
      width: '15%',
      render: (value, record, idx) => {
        let rowSpan = 0;
        let colSpan = 1;
        if (value) {
          if (value === '건의사항') {
            rowSpan = 1;
            colSpan = 3;
          } else {
            rowSpan = 13
          }
        }
        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan, colSpan: colSpan }
        }
      }
    }, {
      title: '상세내용',
      align: 'center',
      width: '13%',
      colSpan: 3,
      dataIndex: 'col2',
      render: (value, record, idx) => {
        let rowSpan = 0;
        let colSpan = 1;
        if (value ) {
          rowSpan = 1;
          if (value === '일자') {
            rowSpan = 5;
          } else if (value === '스터디') {
            rowSpan = 3;
          } else {
            colSpan = 2;
            if (value === '불참교육원') {
              rowSpan = 2;
            } else if (value === '회의록') {
              rowSpan = 2;
            }
          }
        }

        return {
          children: <>{value}</>,
          props: { rowSpan: rowSpan, colSpan: colSpan }
        }
      }
    }, {
      title: '',
      align: 'center',
      width: '10%',
      colSpan: 0,
      dataIndex: 'col3',
      render: (value, record) => {
        let rowSpan = 1;
        if (value === '') {
          rowSpan = 0;
        }

        return {
          children: <>{value}</>,
          props: {
            rowSpan: rowSpan
          }
        }
      }
    }, {
      title: '',
      width: '62%',
      colSpan: 0,
      dataIndex: 'col4',
      render: (value, record, idx) => {
        if (idx > 0) {
          if (data5[idx-1].col2 === '불참교육원' || data5[idx-1].col2 === '회의록' || record.col3 === '결과물') {
            if (record.col4) {
              return <DownloadButton border='none' color='var(--color-blue01)' onClick={() => fnDownloadImg(value)}/>
            } else {
              return <></>
            }
          } else {
            return {
              children: <>{value}</>,
              props: {
                align: 'center'
              }
            }
          }
        }
      }
    }, 
  ]

  const toCloseDetailList = () => {
    navigate(`${URL_ADMIN+URL_ADMIN_BRANCH+URL_BRANCH_CLOSING_REPORT_PERFORMANCE}?mon=${month}`, { state: { branchIdx: branchIdx, year: year, month: month } })
  }


  const fnDownloadExcel = () => {
    
  }


  return (<BaseSection>
      <BaseContainer>
        <Flex justify={'space-between'}>
          <TitleLayout>{year}년 본사직영 {month}월 마감보고서</TitleLayout>
          <Space>
            <FillButton label="실적관리보고서" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={toCloseDetailList} />
            <FillButton label="마감보고서" backgroundColor={'var(--color-blue01)'} />
          </Space>
        </Flex>
        <Divider className="divider" />
        <Row>
          <Col span={24}>
            <Title level={5} >{year}년 지사 사업계획</Title>
            <DataGrid 
              rowKey={'key'}
              data={data1}
              columns={columns1}
              bordered
            />
            <DataGrid 
              rowKey={'key'}
              data={data2}
              columns={columns2}
              bordered
            />
            <DataGrid 
              rowKey={'key'}
              data={data3}
              columns={columns3}
              bordered
            />
            <DataGrid 
              rowKey={'key'}
              data={data4}
              columns={columns4}
              bordered
            />
            <DataGrid 
              rowKey={'key'}
              data={data5}
              columns={columns5}
              bordered
            />
          </Col>
        </Row>
        <Divider className="divider" />
        <Row>
          <Col span={10} />
          <Col span={12}>
            <Space>
              <FillButton label="이전페이지" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={() => toCloseDetailList()} />
              {/* <OutlinedButton label="임시저장" color={'var(--color-blue01)'} onClick={() => saveTemporary() } /> */}
              <FillButton label="다운로드" backgroundColor={'var(--color-blue01)'} onClick={() => fnDownloadExcel()} />
            </Space>
          </Col>
        </Row>
      </BaseContainer>
    </BaseSection>
  )
}